module.exports = function() {

  /**
   *  Rule for validating a regular expression pattern.
   */
  this.pattern = function pattern() {
    if((this.rule.pattern instanceof RegExp)
      && (!this.rule.pattern.test(this.value))) {
      this.raise(
        this.reasons.pattern,
        this.messages.pattern.mismatch,
        this.field, this.value, this.rule.pattern);
    }
  }

}



//////////////////
// WEBPACK FOOTER
// ../node_modules/async-validate/plugin/util/pattern.js
// module id = 1382
// module chunks = 93